import { FC, HTMLAttributes } from 'react'
import { Col } from '@/root/shared-types'
import { TableCell } from '@/root/modules/tuuleliinid/TariffsPage/components/TableCell/TableCell'
import cn from 'classnames'

interface TableHeaderProps extends HTMLAttributes<HTMLDivElement> {
  cols: Col[]
}

export const TableHeader: FC<TableHeaderProps> = ({ cols, className }) => {
  return (
    <div className={cn('border-neutral-very-light grid w-full border', className)}>
      {cols.map(({ key, label }) => (
        <TableCell label={label} key={key} isHeader />
      ))}
    </div>
  )
}
